import * as types from './constants';

// Delete Code
export const deleteCodeRequest = data => (
  { type: types.DELETE_CODE_REQUEST, payload: data }
);

export const deleteCodeDone = data => (
  { type: types.DELETE_CODE_DONE, payload: data }
);

export const deleteCodeFailed = errors => (
  { type: types.DELETE_CODE_FAILED, payload: errors }
);